<mat-card>
  <mat-card-header *ngIf="!widget.meta.hideTitle">
    <mat-card-title
      *ngIf="!changeTitle; else editTitleWidget"
      [matTooltip]="'dashboard.operational.widgets.doubleClickToEditTitle' | t"
      matTooltipPosition="above"
      (dblclick)="editTitle()"
      class="editTitle"
    >
      {{ widget.name }}
      <sn-icon size="xs">edit</sn-icon>
    </mat-card-title>
    <ng-container *ngIf="cameraGrid">
      <button
        mat-icon-button
        *ngIf="canChange"
        icon="swap_horiz"
        [matTooltip]="'dashboard.operational.widgets.changeGrid' | t"
        matTooltipPosition="before"
        (click)="openCameraGridDialog()"
      >
        <mat-icon>swap_horiz</mat-icon>
      </button>
    </ng-container>
  </mat-card-header>
  <mat-card-content>
    <ng-template #placeholder>
      <sn-empty-state icon="apps" [title]="'dashboard.operational.widgets.chooseGridToView' | t" class="placeholder">
        <button mat-flat-button *ngIf="canChange" color="accent" (click)="openCameraGridDialog()">
          {{ 'dashboard.operational.widgets.selectGrid' | t }}
        </button>
      </sn-empty-state>
    </ng-template>

    <ng-template [ngIf]="cameraGrid" [ngIfElse]="placeholder">
      <sn-audit-camera-grid [cameraGrid]="cameraGrid" [allowTimeout]="false">
      </sn-audit-camera-grid>
    </ng-template>
  </mat-card-content>
</mat-card>

<ng-template #editTitleWidget>
  <sn-form-edit-title
    [widget]="widget"
    [viewId]="viewId"
    (title)="setTitle($event)"
    (updateTitle)="setUpdateTitle($event)"
  ></sn-form-edit-title>
</ng-template>
